<template>
    <div>
        <el-row class="mb-1">
            <div>
                <el-divider content-position="left"><i class="el-icon-user-solid"></i> {{ itemTypeName }}</el-divider>
            </div>
        </el-row>
        <el-row class="mb-1">
            <el-col :span="12"><span>规格型号：</span></el-col>
            <el-col :span="12">申请数量：</el-col>
        </el-row>
        <div v-for="(item, index) in applyDetail" :key="index">
            <el-row class="mb-1">
                <el-col :span="11">
                    <el-select v-model="item.id" clearable filterable
                               placeholder="申请领用物品" style="width: 100%;">
                        <el-option
                            v-for="option in options"
                            :key="option.value"
                            :label="option.label"
                            :value="option.value"
                        >
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="5">
                    <el-input type="number" v-model="item.applyQuantity" placeholder="申请数量："></el-input>
                </el-col>
                <el-col :span="8">
                    &nbsp;
                    <el-button type="primary" @click="addDetail" icon="el-icon-plus" class="custom-button"></el-button>
                    <el-button type="danger" @click="removeDetail(index)" :disabled="applyDetail.length <= 1"
                               icon="el-icon-delete" class="custom-button">
                    </el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        itemTypeName: {
            type: String,
            required: true
        },
        applyDetail: {
            type: Array,
            required: true
        },
        options: {
            type: Array,
            required: true
        }
    },
    methods: {
        addDetail() {
            this.$emit('add-detail');
        },
        removeDetail(index) {
            this.$emit('remove-detail', index);
        }
    }
};
</script>

<style scoped>
.custom-button {
    width: 5%;
    display: inline-flex; /* 使用内联弹性布局 */
    justify-content: center;
    align-items: center;
}
</style>